import { render, staticRenderFns } from "./Murojaatlar.vue?vue&type=template&id=42edca32&scoped=true&"
import script from "./Murojaatlar.vue?vue&type=script&lang=js&"
export * from "./Murojaatlar.vue?vue&type=script&lang=js&"
import style0 from "./Murojaatlar.vue?vue&type=style&index=0&id=42edca32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42edca32",
  null
  
)

export default component.exports